import { render, staticRenderFns } from "./AdminConfig.vue?vue&type=template&id=4e36a781&scoped=true&"
import script from "./AdminConfig.vue?vue&type=script&lang=js&"
export * from "./AdminConfig.vue?vue&type=script&lang=js&"
import style0 from "./AdminConfig.vue?vue&type=style&index=0&id=4e36a781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36a781",
  null
  
)

export default component.exports